module.exports = __webpack_public_path__ + "images/Megafon.b5633010cfb89b5973013c150a83ffe8.png";